var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChina({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_17_6951)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17_6951",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17_6951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2819 3H3V23H37.2819V3Z",
    fill: "#CB2127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.30098 10.238L6.94376 8.24271L5.24976 7.00401L7.3455 6.99731L8.00168 5.0087L8.65116 6.99731L10.7469 7.00401L9.0529 8.24271L9.69569 10.238L8.00168 9.00602L6.30098 10.238Z",
    fill: "#F7DE28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1463 11.316L12.8561 11.5972L13.3448 11.0147L13.2913 11.778L14.001 12.0659L13.2578 12.2534L13.2042 13.01L12.7958 12.3673L12.0593 12.548L12.5481 11.9588L12.1463 11.316Z",
    fill: "#F7DE28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9762 7.4794L15.2263 7.35218L14.8647 8.02175L14.7576 7.26513L14.0077 7.13122L14.6907 6.79644L14.5835 6.03983L15.1192 6.58887L15.8021 6.25409L15.4473 6.93035L15.9762 7.4794Z",
    fill: "#F7DE28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3827 10.8942L14.617 10.1711L14.001 9.72246H14.7643L14.9987 8.99263L15.233 9.72246H15.9963L15.3803 10.1711L15.6147 10.8942L14.9987 10.4523L14.3827 10.8942Z",
    fill: "#F7DE28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1798 4.27217L12.8761 4.58687L13.3984 4.03113L13.3047 4.78774L13.9943 5.11583L13.2444 5.26313L13.1507 6.01975L12.7824 5.35018L12.0325 5.49748L12.548 4.93505L12.1798 4.27217Z",
    fill: "#F7DE28"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_17_6951",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_6951"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_6951",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChina);
export default __webpack_public_path__ + "static/media/China.af56fcac56f4abb4e14ea7f4b3417528.svg";
export { ForwardRef as ReactComponent };